// @flow
import AppVersion from 'app/common/lib/AppVersion';
import BrowserDetector from 'app/common/lib/BrowserDetector';
import Csrf from 'app/common/lib/Csrf';
import experiments from 'app/common/lib/experiments';
import urlUtil from 'app/common/lib/urlUtil';
import ajax, { type Options } from 'app/packages/api/ajax';

export const ajaxWithAbort = (options: Options) =>
  ajax(options, {
    csrf: {
      isRequired: Csrf._needsCsrfToken,
      errorIfMissing: false,
      getToken: Csrf.getCSRFToken,
    },
    getAppVersion: () => AppVersion.currentVersion,
    appendQuery: urlUtil.appendQueryString,
    buildQuery: urlUtil.getQueryStringFromObject,
    experimentGroups: {
      async: experiments.getInstance().v2ActivateExperiment('mweb_web_prefer_fetch_api') || '',
      sync: experiments.getInstance().v2ActivateExperiment('web_unload_fetch_keep_alive_2') || '',
    },
    statsLogTags: {
      browser: BrowserDetector.getBrowserName(),
      platform: 'desktop',
    },
  });

const desktopAjax = (options: Options) => ajaxWithAbort(options).promise;

export default desktopAjax;
